const svgSpinner = `
<head>
  <style>
    html, body {
      height: 100%;
      width: 100%;
    }
  
    @keyframes spinner-svg {
      0% {
          transform: rotate(0deg);
          stroke-dashoffset: 66px;
      }
      50% {
          transform: rotate(720deg);
          stroke-dashoffset: 314px;
      }
      100% {
          transform: rotate(1080deg);
          stroke-dashoffset: 66px;
      }
    }
    
    .spinnerContainer {
      position: fixed;
      top: 50%;
      left: 50%;
      margin-top: -50px;
      margin-left: -50px;
      width: 100px;
      height: 100px;
    }
    
    .spinnerSvg {
      width: 100px;
      height: 100px;
    }
    
    .spinnerSvgCircle {
      fill: transparent;
      stroke-linecap: round;
      stroke: rgb(61, 132, 209);
      stroke-dasharray: 314.16;
      transform-origin: 50px 50px 0px;
      animation-name: spinner-svg;
      animation-timing-function: linear;
      animation-duration: 2s;
      animation-delay: 0s;
      animation-iteration-count: infinite;
      stroke-width: 8;
    }
  </style>
</head>
<body>
  <div class="spinnerContainer">
    <svg class="spinnerSvg">
      <circle cx="50" cy="50" r="46" class="spinnerSvgCircle"></circle>
    </svg>
  </div>
</body>`;

export default window => {
  window.document.write(svgSpinner);
};
